var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "progress-bar",
        {
          "no-progress": _vm.noProgressMade
        }
      ],
      attrs: {
        role: "progressbar",
        "aria-label": "Progress: " + _vm.percentComplete
      }
    },
    [
      _c("span", {
        style: {
          width: _vm.percentComplete + "%"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }